export default __webpack_public_path__ + "static/media/prev-C1A-5.5cbb3535.png";